import { useEffect, useState } from 'react';
import useCountDown from 'react-countdown-hook';
import { addMilliseconds } from 'date-fns';
import { calculateExpiryTimeLeft } from 'src/common/helpers/date/date';
import { ExtendTimeLeftProps } from './extend-time-left.types';
export const ExtendTimeLeft = ({
  pauseTime
}: ExtendTimeLeftProps) => {
  const [timeLeft, {
    start
  }] = useCountDown(pauseTime.getTime() - Date.now(), 1000);
  const [timeLeftFormatted, setTimeLeftFormatted] = useState(calculateExpiryTimeLeft(new Date(timeLeft), new Date()));
  useEffect(() => {
    start(pauseTime.getTime() - Date.now());
  }, [pauseTime, start]);
  useEffect(() => {
    setTimeLeftFormatted(calculateExpiryTimeLeft(new Date(addMilliseconds(new Date(), timeLeft)), new Date()));
  }, [timeLeft]);
  if (timeLeftFormatted.days > 0) {
    return <span data-testid="time-formatted-wrapper">({timeLeftFormatted.days} days left)</span>;
  }
  return <span data-testid="time-formatted-wrapper" data-sentry-component="ExtendTimeLeft" data-sentry-source-file="extend-time-left.tsx">
      {timeLeftFormatted.hours || timeLeftFormatted.minutes ? '(' : ''}
      {timeLeftFormatted.hours ? <span data-testid="time-formatted-hour">{`${timeLeftFormatted.hours}h `}</span> : ''}
      {timeLeftFormatted.minutes ? <span data-testid="time-formatted-minutes">{`${timeLeftFormatted.minutes}min`}</span> : ''}
      {timeLeftFormatted.hours || timeLeftFormatted.minutes ? ' left' : ''}
      {timeLeftFormatted.hours || timeLeftFormatted.minutes ? ')' : ''}
    </span>;
};